export default "__VITE_ASSET__a5b4dcb4__"